"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _FakeLoader = _interopRequireDefault(require("./FakeLoader"));

exports["default"] = _FakeLoader["default"];